import { StarRow } from "~/assets/assets";

export default function NielsenHeader() {
  const purpleFontStyle =
    "text-[24px] sm:text-[44px] font-semibold leading-[1.3] tracking-[-0.64px] sm:tracking-[-0.88px] text-text-normal-primary";
  return (
    <div class={`flex flex-col items-center justify-center ${purpleFontStyle}`}>
      <div class="mt-7 sm:mt-4"></div>
      <div class="flex items-center gap-2">
        <StarRow
          starSizes={[2, 3.5]}
          fillColor="#E47B00"
          altFillColor="#8B651B"
          breakpoint="lg"
        />
        <div
          class={`font-sacramento text-h1 font-normal tracking-[0px] text-[#8B651B] lg:text-orange`}
        >
          Congratulations
        </div>
        <StarRow
          starSizes={[3.5, 2]}
          fillColor="#E47B00"
          altFillColor="#8B651B"
          breakpoint="lg"
        />
      </div>
      <div class="mt-2"></div>
      <span class="flex">Enjoy deals from</span>
      <span class="flex">400+ brands </span>
    </div>
  );
}
